import { DecimalPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ContractorService } from 'src/app/Services/contractor.service';
import { ProjectService } from 'src/app/Services/project.services';
import { ProjectContractorService } from 'src/app/Services/projectcontractor.service';
import { Contractor } from 'src/app/objects/Contractor';
import { Project, ProjectContractor, ProjectMaterial } from 'src/app/objects/Project';
import { MatDialog } from '@angular/material/dialog';

import { SortService } from '../../sort.service';

import { MatTableDataSource } from '@angular/material/table'; 
import { ProjectMaterialService } from 'src/app/Services/projectMaterials';
import { ProjectMaterialAddComponent }from '../project-material-add/project-material-add.component'; 
import { Materials } from 'Materials';
import { ProjectContractorsAddComponent } from '../project-contractors-add/project-contractors-add.component';


@Component({
  selector: 'app-project-contractors',
  templateUrl: './project-contractors.component.html',
  styleUrls: ['./project-contractors.component.css']
})
export class ProjectContractorsComponent implements OnInit {
  
  project!: Project;
  projectContractors: any;
  dataSource: MatTableDataSource<ProjectContractor> | undefined;
  materialsService: any;
  materials: any;
  isLoadingResults: boolean | undefined; 
  showAvailbleMaterials: boolean | undefined; 
  isMobile= false; 
  items: any[] = [];
  constractors: Contractor []=[];
  // ProjectMaterials: ProjectMaterial []=[];
  sortProperty: string = 'id';
  sortOrder = 1;
  sortListProperty: string = 'id';
  sortListOrder = 1;
  ProjectObject?: Project []=[];

  ProjectContractorsColumns: string[] = ['imagecontent', 'name',  'age', 'jobTitle','cellPhone','email','salary','hourlyWage'];
 

  editedRow: ProjectContractor | undefined;
  ProjectId: number | undefined;

  constructor( private route: ActivatedRoute,private sortService: SortService,
    private router: Router,
    private contractorService: ContractorService,
    private projectMaterialService: ProjectMaterialService,
    private projectService: ProjectService,
    private projectContractorService: ProjectContractorService,
    private dialog: MatDialog) {
     }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.ProjectId = parseInt(params.get('id') || '0', 10);
      if (this.ProjectId > 0) {
        this.loadProject(this.ProjectId);
      }
    }); 
    this.getContracors()
  }

  cancelEdit(element: ProjectContractor) {
    // Restore original values
    this.editedRow = undefined;
  }
  editRow(element: ProjectContractor) {
   
    this.editedRow = element; // {element };
  }

  loadProject(projectId: number) {
  
    this.projectService.getProject(projectId).subscribe((project: Project) => {
      this.project = project;
       
    this.projectContractors = project.contractors;
    //this.projectMaterials.sort(a=>purchasedQty )

 
    this.dataSource = new MatTableDataSource<ProjectContractor>(project.contractors);
      console.log(this.dataSource)
        console.log(this.project.contractors); 
        
    });
 
  }

 

  openProjectContractorAdd(): void {
     
console.log( this.project.id );
     
    let dialogRef = this.dialog.open(ProjectContractorsAddComponent, {
      height: '90%',
      width: '95%',
      data: { projectId: this.project.id }
    });

    dialogRef.afterClosed().subscribe(() => {
      if (this.project.id) { this.loadProject(this.project.id); }
    });
  }



  getContracors()
  {
    this.contractorService.getContractors().subscribe((contractors) => {
      this.constractors = contractors;
    
       console.log(contractors);
      
    });

  }

  
  removeContractorfromProject(contractor: ProjectContractor): void {
    if (!confirm('Are you sure you want to remove this contractor from the project?')) { return; }

    this.projectContractorService.deleteProjectContractor(contractor).subscribe({
      next: () => {
        if (this.project.id) { this.loadProject(this.project.id); }
      },
      error: (err) => {
        console.error('Failed to remove contractor:', err);
      }
    });
  }
  
    saveEdit(element: ProjectContractor) {
      // Update data source with edited values
  //     let projectTasks: ProjectContractor[]= this.project.projectTasks!;
  //     let m:ProjectContractor | any
  //     debugger
  //     m = projectTasks.find(a=> a.id = element.id);
  //     m.title = element.title;
  //     m.description = element.description;
  //     m.dueDate = element.dueDate;
  //     m.assignedTo = element.assignedTo;
  //     m.completed = element.completed; 
  // debugger
  //     if (m !== undefined) { 
  //       this.projectTaskService.updateProjectTask(m)
  //     .subscribe(res => {
         
          
  //         this.isLoadingResults = false;
  //         console.log('Project edited successfully!');
  //         this.loadProject(this.project?.id);
  //       }, (err) => {
  //         console.log(err);
  //         this.isLoadingResults = false;
  //       });
  //     } 
  //     this.editedRow = undefined;
   // }
  }
}
